import { render, staticRenderFns } from "./Swoggle.vue?vue&type=template&id=2dfa42a4&scoped=true"
import script from "./Swoggle.vue?vue&type=script&lang=js"
export * from "./Swoggle.vue?vue&type=script&lang=js"
import style0 from "./Swoggle.vue?vue&type=style&index=0&id=2dfa42a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa42a4",
  null
  
)

export default component.exports